import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Button,
  Card,
  Dropdown,
  Icon,
  Input,
  Label,
} from 'semantic-ui-react';

import { compose } from 'recompose';
import TargetLink from '../../components/target-link';
import { renderCurrencySymbol } from '../../utils/helpers/currencies';

import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';

import { INVENTORY_HELP_LINK } from '../../containers/organisation-inventory';

const currencyLabelStyle = {
  paddingTop: 13,
};

const deleteIconStyle = {
  float: 'right',
};

const assignedItemStyle = {
  width: '100%',
  marginBottom: 8,
  lineHeight: '26px',
};

const dropdownStyle = {
  marginTop: 5,
};

const iconMarginLeftStyle = {
  marginLeft: 5,
};

class CollaborationBudget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddingInventoryItems: false,
      isLoadingInventoryItems: false,
      inventoryItems: [],
      selectedInventoryItems: [],
      value: props.budget || 0,
      isEditing: false,
    };
  }

  async componentDidMount() {
    await this.loadInventoryItems();
  }

  loadInventoryItems = async () => {
    const { restClient, userInfo: { organisationId }, discussionId } = this.props;
    const response = await restClient(`inventoryItems?filter[organisation]=${organisationId}`);
    const discussionResponse = await restClient.get(`discussions/${discussionId}`);
    const selectedInventoryItems = _.get(discussionResponse, 'data.data.relationships.inventoryItems.data', []);
    const inventoryItems = _.get(response, 'data.data', []);
    this.setState({
      inventoryItems,
      selectedInventoryItems,
      isLoadingInventoryItems: false,
    });
  }

  onChange = (e, { value }) => this.setState({
    value,
  });

  toggleInventoryAddBlockVisibility = () => this.setState({
    isAddingInventoryItems: true,
  });

  onDeleteInventoryItem = async inventoryItemId => {
    const { restClient, discussionId } = this.props;
    const data = _.reject(this.state.selectedInventoryItems, ['id', inventoryItemId]);
    await restClient.patch(`discussions/${discussionId}/relationships/inventoryItems`, {
      data,
    });
    this.setState({
      selectedInventoryItems: data,
    });
  }

  onInventoryItemSelected = async (event, { value }) => {
    const { restClient, discussionId } = this.props;
    const data = _.get(this.state, 'selectedInventoryItems', []);
    data.push({
      id: value,
      type: 'inventoryItems',
    });
    await restClient.patch(`discussions/${discussionId}/relationships/inventoryItems`, {
      data,
    });
    this.setState({
      isAddingInventoryItems: false,
      selectedInventoryItems: data,
    });
  }

  toggleInputState = () => this.setState({
    isEditing: !this.state.isEditing,
  })

  persistBudget = async fee => {
    const { saveNewBudget } = this.props;
    await saveNewBudget(fee);
    this.setState({
      value: fee,
      isEditing: false,
    });
  }

  render() {
    const {
      campaignCurrency,
    } = this.props;

    const {
      value,
      isEditing,
      inventoryItems,
      isAddingInventoryItems,
    } = this.state;

    const labelProps = {
      content: renderCurrencySymbol(campaignCurrency),
      basic: true,
      style: currencyLabelStyle,
    };

    const inputActionProps = {
      icon: isEditing ? 'save' : 'pencil',
      onClick: isEditing ? () => this.persistBudget(value) : this.toggleInputState,
      disabled: isEditing && _.isEmpty(value),
      color: isEditing ? 'pink' : 'green',
    };

    const options = _.map(inventoryItems, item => ({
      key: _.get(item, 'attributes.value'),
      value: _.get(item, 'id'),
      text: `${_.get(item, 'attributes.value')} -  ${renderCurrencySymbol(campaignCurrency)} ${_.get(item, 'attributes.monetaryValue')} `,
    }));

    const availableOptions = _.filter(options, option => {
      const foundItem = _.find(_.get(this.state, 'selectedInventoryItems'), ['id', _.get(option, 'value')]);
      return _.isNil(foundItem);
    });

    const existingInventoryItems = _.map(this.state.selectedInventoryItems, item => _.find(this.state.inventoryItems, ['id', _.get(item, 'id')]));

    const hasAvailableOptions = !_.isEmpty(availableOptions);

    return (
      <Card fluid>
        <Card.Content>
          <h3>Fee: Paid to influencer</h3>
        </Card.Content>
        <Card.Content>
          <Input
            fluid
            type="number"
            onChange={this.onChange}
            disabled={!isEditing}
            label={labelProps}
            defaultValue={value}
            value={value}
            action={inputActionProps}
          />
        </Card.Content>
        <Card.Content>
          <h3>Gift: Value of gifts provided
            <TargetLink href={INVENTORY_HELP_LINK} renderIf>
              <Icon name="info circle" color="green" style={iconMarginLeftStyle} />
            </TargetLink>
          </h3>
        </Card.Content>
        <Card.Content>
          {
            _.isEmpty(existingInventoryItems) && <span>No assigned gifts.</span>
          }
          {
            !_.isEmpty(existingInventoryItems) && _.map(existingInventoryItems, item => (
              <Label key={_.get(item, 'id')} basic size="large" style={assignedItemStyle}>
                { _.get(item, 'attributes.value') } ({renderCurrencySymbol(campaignCurrency)} { _.get(item, 'attributes.monetaryValue') })
                <Icon onClick={() => this.onDeleteInventoryItem(_.get(item, 'id'))} name="delete" style={deleteIconStyle} circular />
              </Label>
            ))
          }
          {
            isAddingInventoryItems &&
            <Dropdown
              style={dropdownStyle}
              placeholder="Select inventory item"
              fluid
              search
              selection
              onChange={this.onInventoryItemSelected}
              options={availableOptions}
            />
          }
        </Card.Content>
        {
          !isAddingInventoryItems && hasAvailableOptions &&
          <Card.Content>
            <Button
              style={dropdownStyle}
              fluid
              floated="right"
              content="Assign gift item"
              color="green"
              onClick={this.toggleInventoryAddBlockVisibility}
            />
          </Card.Content>
        }

      </Card>
    );
  }
}

CollaborationBudget.propTypes = {
  budget: PropTypes.any.isRequired,
  campaignCurrency: PropTypes.string.isRequired,
  saveNewBudget: PropTypes.func.isRequired,
  discussionId: PropTypes.string.isRequired,
};

export default compose(
  hasRESTClient,
  hasUserInfo,
)(CollaborationBudget);



/** WEBPACK FOOTER **
 ** ./src/components/collaboration-budget/index.js
 **/